import styled from 'styled-components'

import TokenOriginal from 'components/Token'
import ConfirmButton from 'components/Buttons/ConfirmButton'
import { colors } from 'themes'

import tokenWhite from 'images/tokenWhite.svg'
import resume from 'images/resume.svg'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	
	position: relative;
	background: ${colors.tokens.background};
	border-radius: 14px;
	padding: 26px;
	color: ${colors.tokens.mainText};
	font-weight: normal;
	
	.useTokens {
		margin-top: 9px;
	}
	.firstTokens {
		margin: 19px 0;
	}
`

export const TokenRow = styled.div`
	margin: 17px 0;
	font-weight: bold;
	
	div, & {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.equals {
		margin: 0px 10px;
		font-size: 1.71em;
	}
`

export const TokenIcon = styled.img.attrs({
	src: tokenWhite,
})`
	width: 28px;
	height: 20px;
	margin-right: 10px;
`

export const ResumeIcon = styled(TokenIcon).attrs({
	src: resume,
})`

`

export const Token = styled(TokenOriginal)`
	pointer-events: none;
	margin: 0;
`

export const HorizontalSeparator = styled.div`
	border: 1px solid ${colors.tokens.mainText};
	margin: 21px 0 27px;
	opacity: 0.5;
`

export const GotItButton = styled(ConfirmButton).attrs({
	className: 'white'
})`
	padding: 10px 80px !important;
	color: #1F8CB2 !important;
	align-self: center;
	border-radius: 200px;
`
